import { Box, TableCell, TableHead, TableRow } from "@mui/material";
import { Fragment } from "react";
import InfoTooltip from "../InfoTooltip/InfoTooltip";
import { FormTableHeader } from "./FormTable";

type Props = {
  headers: FormTableHeader[];
  disableEditRow?: boolean;
  disableDeleteRow: boolean;
};

const FormTableHeaders = ({
  headers,
  disableEditRow,
  disableDeleteRow,
}: Props) => {
  return (
    <TableHead>
      <TableRow>
        {headers.map((header, index) => (
          <Fragment key={`formtable-tableHeader-row-${index}`}>
            <TableCell
              sx={{
                padding: "0.5rem",
                fontSize: "12px",
                fontWeight: 400,
              }}
            >
              <Box style={{ display: "flex", alignItems: "center" }}>
                {header.text === "more" ? "" : header.text}
                {header.tooltip && (
                  <InfoTooltip
                    title={header.tooltip}
                    style={{ marginLeft: "6px" }}
                    slotProps={{ popper: { sx: { whiteSpace: "pre-line" } } }}
                  />
                )}
              </Box>
            </TableCell>
          </Fragment>
        ))}
        {!disableEditRow && <TableCell />}
        {!disableDeleteRow && <TableCell />}
      </TableRow>
    </TableHead>
  );
};

export default FormTableHeaders;
